<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M7.14804 2.97721L12.773 8.60221C12.8253 8.65445 12.8668 8.71649 12.8951 8.78477C12.9234 8.85306 12.938 8.92625 12.938 9.00018C12.938 9.0741 12.9234 9.14729 12.8951 9.21558C12.8668 9.28387 12.8253 9.3459 12.773 9.39815L7.14804 15.0231C7.04249 15.1287 6.89934 15.188 6.75007 15.188C6.6008 15.188 6.45765 15.1287 6.3521 15.0231C6.24655 14.9176 6.18726 14.7744 6.18726 14.6252C6.18726 14.4759 6.24655 14.3328 6.3521 14.2272L11.5798 9.00018L6.3521 3.77314C6.29984 3.72088 6.25838 3.65884 6.2301 3.59056C6.20181 3.52227 6.18726 3.44909 6.18726 3.37518C6.18726 3.30127 6.20181 3.22808 6.2301 3.1598C6.25838 3.09151 6.29984 3.02947 6.3521 2.97721C6.40436 2.92494 6.46641 2.88349 6.53469 2.8552C6.60297 2.82692 6.67616 2.81236 6.75007 2.81236C6.82398 2.81236 6.89716 2.82692 6.96545 2.8552C7.03373 2.88349 7.09578 2.92494 7.14804 2.97721Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChevronRight',
};
</script>
